export const NAV_LINKS = [
  { label: "Nature Pulse", to: "/pulse" },
  { label: "Weather Almanac", to: "/weather-almanac" },
  { label: "Stories", to: "/stories" },
  { label: "News", to: "/news" },
  { label: "Observations", to: "/observations" },
  { label: "Map", to: "/map" },
  { label: "Geo Tree", to: "/geo" },
  { label: "Mission", to: "/manifesto" },
  { label: "Articles", to: "/articles" },
  { label: "Alerts", to: "/notifications" },
  { label: "Challenges", to: "/challenges" },
  { label: "Research", to: "/research" },
  { label: "Experts", to: "/experts" },
  { label: "Write", to: "/publisher" },
  { label: "Nature Museum", to: "/nature-museum" },
  { label: "PhotoPulse", to: "/photopulse" },
  { label: "Climate Hub", to: "/climate-change" },
  { label: "FAQ", to: "/faq" },
  { label: "About", to: "/about" },
  { label: "Contact", to: "/contact" },
];

export const NAV_EXTERNAL = [
  { label: "Farmers Pulse", to: "https://farmerspulse.com" },
  { label: "Social Pulse", to: "https://socialpulse.com" },
  { label: "Food Pulse", to: "https://foodpulse.net" },
  { label: "Alumni Pulse", to: "https://alumnipulse.net" },
];

export const MARQUEE_TERMS = [
  "GLACIER RETREAT", "51.5074°N 0.1278°W", "APR 2025 · +1.54°C",
  "ARCTIC SEA ICE", "CO₂ · 424.6 PPM", "28.6139°N 77.2090°E",
  "MONSOON DRIFT", "AURORA A-INDEX 32", "PACIFIC SST +1.9°",
  "GREAT BARRIER · BLEACH 4", "AMAZON · −11%", "35.6762°N 139.6503°E",
  "FIRE SEASON EXTENDING", "SEA LEVEL +101 MM", "PERMAFROST −0.4M",
];

export const CATEGORIES = [
  { key: "plants",     label: "Plants",     emoji: "🌳" },
  { key: "agriculture",label: "Agriculture",emoji: "🌾" },
  { key: "insects",    label: "Insects",    emoji: "🦋" },
  { key: "birds",      label: "Birds",      emoji: "🐦" },
  { key: "wildlife",   label: "Wildlife",   emoji: "🐘" },
  { key: "aquatic",    label: "Aquatic",    emoji: "🐠" },
  { key: "fungi",      label: "Fungi",      emoji: "🍄" },
  { key: "landscapes", label: "Landscapes", emoji: "🌄" },
  { key: "water",      label: "Water",      emoji: "💧" },
  { key: "geology",    label: "Geology",    emoji: "🪨" },
  { key: "weather",    label: "Weather",    emoji: "☀️" },
];
